import { Message, MessageStatus, MessageType, OwnerTypeMessage } from "../models/Message";
import { removeFormattingMarksPreservingSpacing } from "./channelAndHtml";

const forwardableTypes = new Set<MessageType>([
  MessageType.TEXT,
  MessageType.IMAGE,
  MessageType.VIDEO,
  MessageType.AUDIO,
  MessageType.DOCUMENT,
  MessageType.STICKER,
  MessageType.LOCATION,
  MessageType.LIVE_LOCATION,
  MessageType.CONTACT,
  MessageType.POLL,
]);

const isAvailableMessage = ( message: Message ): boolean => !message.deletedAt && !message.channelDeletedAt;

export const canCopyMessage = ( message: Message ): boolean => (
  isAvailableMessage( message ) && message.messageType === MessageType.TEXT
);

export const canForwardMessage = ( message: Message ): boolean => (
  isAvailableMessage( message ) && forwardableTypes.has( message.messageType )
);

export const canRetryPersistedMessage = ( message: Message ): boolean => (
  isAvailableMessage( message ) &&
  message.ownerType === OwnerTypeMessage.USER &&
  message.status === MessageStatus.FAILED &&
  !message.localUpload &&
  forwardableTypes.has( message.messageType )
);

export const copyMessageToClipboard = async (
  message: Message,
  feedback: ( text: string, variant: "success" | "error" ) => void,
  writeText: (( text: string ) => Promise<void>) | undefined = typeof navigator !== "undefined" ? navigator.clipboard?.writeText?.bind( navigator.clipboard ) : undefined,
): Promise<boolean> => {
  if( !canCopyMessage( message ) || !writeText ) {
    feedback( "Não foi possível copiar a mensagem", "error" );
    return false;
  }

  try {
    await writeText( removeFormattingMarksPreservingSpacing( message.content ?? "" ));
    feedback( "Mensagem copiada", "success" );
    return true;
  } catch {
    feedback( "Não foi possível copiar a mensagem", "error" );
    return false;
  }
};
